export default [
  {
    path: '/product/list',
    name: 'product-list',
    component: () => import('@/views/products/products-list/ProductsList.vue'),
   
  },
  {
    path: '/product/view/:id/:isEdit',
    name: 'product-view-new',
    component: () => import('@/views/products/products-view/ProductsView.vue'),
   
  },
  {
    path: '/product/edit/:id',
    name: 'product-edit',
    component: () => import('@/views/products/products-edit/ProductEdit.vue'),
    
  },
  {
    path: '/product/add/:id',
    name: 'product-add',
    component: () => import('@/views/products/products-edit/ProductEdit.vue'),
  },
]
